<template>
  <ColorPickerPopover
    v-if="useAIPageRevamp"
    :id="id"
    :label="label"
    :required="required"
    :disabled="disabled"
    :initialColor="initialColor"
    @colorChange="$emit('colorChange', $event)"
  />
  <StudioColorPickerInput
    v-else
    :id="id"
    :label="label"
    :type="type"
    :initialColor="initialColor"
    :initialGradient="initialGradient"
    :disabled="disabled"
    :useFixedPositioning="useFixedPositioning"
    @colorChange="$emit('colorChange', $event)"
    @gradientChange="$emit('gradientChange', $event)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

import ColorPickerPopover from './ColorPickerPopover.vue';

import StudioColorPickerInput from '@/studioComponents/StudioColorPickerInput.vue';

const props = defineProps({
  id: { type: String, default: '' },
  label: { type: String, default: '' },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  type: { type: String, default: 'color' },
  initialColor: { type: String, default: 'rgba(0, 0, 0, 1)' },
  initialGradient: { type: Object, default: null },
  useFixedPositioning: { type: Boolean, default: false }
});

defineEmits<{
  colorChange: [color: { red: number; green: number; blue: number; alpha: number; style: string; hex?: string }];
  gradientChange: [
    gradient: {
      type: string;
      colors: { red: number; green: number; blue: number; alpha: number; style: string; hex?: string }[];
    }
  ];
}>();

const store = useStore();

const useAIPageRevamp = computed<boolean>(() => {
  const organization = store.getters['org/getCurrentOrg'];
  return organization?.useAIPageRevamp || false;
});
</script>
